// ZEO "Aufgabe / Vorgang wechseln" (02.11.2026): serverseitige Aufgabensuche statt Dropdown aller Aufgaben.
// Nutzt GET /api/betreuung/aufgaben/suche (Aufgabenverwaltung 2.0). Standard: nur der Klient des Chats; "Alle Betreuten" ist eine
// bewusste Umschaltung, deren klientenfremde Treffer NICHT in den aktuellen Chat uebernommen werden koennen (Server prueft zusaetzlich).

export const PRO_SEITE = 10;
export const STATUS_FILTER = [['offen', 'Offen'], ['wartend', 'Wartend'], ['ueberfaellig', 'Überfällig'], ['erledigt', 'Erledigt'], ['alle', 'Alle']];
export const STATUS_LABEL = { offen: 'offen', in_bearbeitung: 'in Bearbeitung', wartend: 'wartend', erledigt: 'erledigt' };

export function suchParameter({ q = '', filter = 'offen', herkunft = 'alle', bereich = 'klient', klientId = '', seite = 1 }) {
  const p = { q: q.trim() || undefined, seite: Math.max(1, seite), pro_seite: PRO_SEITE, sort: 'faellig_asc' };
  if (bereich !== 'alle') p.klient_id = klientId;
  if (filter === 'ueberfaellig') { p.status = 'offen'; p.faelligkeit = 'ueberfaellig'; } else if (filter && filter !== 'alle') p.status = filter;
  if (herkunft && herkunft !== 'alle') p.herkunft = herkunft;
  return p;
}

/** Nur echte, aufloesbare Aufgaben des Chat-Klienten sind waehlbar. */
export function auswaehlbar(aufgabe, klientId) {
  return Boolean(aufgabe?.id) && Boolean(klientId) && aufgabe.klient_id === klientId;
}

export function seiten(gesamt, pro = PRO_SEITE) {
  return Math.max(1, Math.ceil((Number(gesamt) || 0) / pro));
}

export function faelligkeit(a) {
  const d = a?.faelligkeit || a?.faellig_am || a?.['fällig_am'];
  return d ? String(d).slice(0, 10) : null;
}
